// Debug: Afficher toutes les variables VITE au démarrage
console.log('[SSO Config] Environment variables:', {
  VITE_OAUTH_AUTHORITY: import.meta.env.VITE_OAUTH_AUTHORITY,
  VITE_OAUTH_CLIENT_ID: import.meta.env.VITE_OAUTH_CLIENT_ID,
  VITE_APP_BASE_URL: import.meta.env.VITE_APP_BASE_URL,
});

// Validation des variables d'environnement requises
const validateConfig = () => {
  const requiredVars = [
    'VITE_OAUTH_CLIENT_ID',
    'VITE_APP_BASE_URL',
    'VITE_OAUTH_AUTHORITY',
  ];

  const missingVars = requiredVars.filter(
    (varName) => !import.meta.env[varName]
  );

  if (missingVars.length > 0) {
    console.error(
      "[SSO Config] Variables d'environnement manquantes:",
      missingVars
    );
    throw new Error(
      `Configuration SSO incomplète. Variables manquantes: ${missingVars.join(', ')}`
    );
  }

  // Validation de l'URL d'autorité
  const authority = import.meta.env.VITE_OAUTH_AUTHORITY;
  if (!authority.startsWith('http://') && !authority.startsWith('https://')) {
    console.error(
      '[SSO Config] VITE_OAUTH_AUTHORITY doit commencer par http:// ou https://'
    );
    throw new Error(
      "URL d'autorité OAuth invalide. Doit commencer par http:// ou https://"
    );
  }

  console.log('[SSO Config] Validation passed ✓');
};

// Valider la configuration au chargement
try {
  validateConfig();
} catch (error) {
  console.error('[SSO Config] Erreur:', error.message);
  // Stocker l'erreur pour l'afficher dans la page d'erreur
  sessionStorage.setItem(
    'authError',
    JSON.stringify({
      message: 'Erreur de configuration SSO',
      details: error.message,
      timestamp: new Date().toISOString(),
    })
  );
}

export const oidcConfig = {
  client_id: import.meta.env.VITE_OAUTH_CLIENT_ID,
  redirect_uri: `${import.meta.env.VITE_APP_BASE_URL}/auth/callback/`,
  silent_redirect_uri: `${import.meta.env.VITE_APP_BASE_URL}/auth/silent-callback`,
  authority: import.meta.env.VITE_OAUTH_AUTHORITY,
  post_logout_redirect_uri: `${import.meta.env.VITE_APP_BASE_URL}/dashboard/products`,
  response_type: 'code',
  scope: 'openid profile email',
  loadUserInfo: true,
  automaticSilentRenew: true,
  silentRequestTimeout: 2000,
  monitorSession: true,
  onSigninSilent: () => {
    // Ne rien faire, l'authentification sera déclenchée manuellement
  },
  silentRequestOnError: (error) => {
    console.error('[silentRequestOnError]');
    console.error(error);
    if (error.error === 'login_required') {
      window.location.href = '/auth/sso';
    }
  },
};
